// Internal Imports
import { AUTH } from "../../constants";
import { GlobalUtils } from "../../utils";

// Destructuring
const {
  DOMAIN_NAME,
  WEBSITE_DOMAIN_URL,
  GOOGLE_AUTH_CLIENT_CODES_MAP,
  LOCAL,
  AUTH_URL,
} = AUTH;
const { readDataFromLocalStorage } = GlobalUtils;

// check if User is authenticated or not
export const isUserAuthenticated = () => {
  const user = readDataFromLocalStorage("revvsalesUser");
  if (user && user.org_id && user.access_token) {
    return true;
  }
  return false;
};

// get user's valid domain url
export const getValidDomainUrl = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  return WEBSITE_DOMAIN_URL[envName];
};

// get user's valid subdomain url
export const getValidSubDomainUrl = subdomain => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  if (envName === LOCAL) {
    return `http://${DOMAIN_NAME[envName]}`;
  }
  return `https://${subdomain}.${DOMAIN_NAME[envName]}`;
};

// get user's valid subdomain full url
export const getValidFullSubDomainUrl = subdomain => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  const { pathname, search } = window.location;
  if (envName === LOCAL) {
    return `http://${DOMAIN_NAME[envName]}${pathname}${search}`;
  }
  return `https://${subdomain}.${DOMAIN_NAME[envName]}${pathname}${search}`;
};

// get the google auth client code based on env name
export const getGoogleAuthClientCode = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  return GOOGLE_AUTH_CLIENT_CODES_MAP[envName];
};

export const getRedirectUrlPostSignout = () => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  return AUTH_URL[envName];
};



// WEBPACK FOOTER //
// ./src/actions/AuthActions/authMethods.js